import { useEffect } from "react";
import { ReactComponent as PopUpDesign } from "../../assets/img/transactionPopupDesign.svg";
import { useFundWalletStore } from "../../store/fundWallet";
import { AmountStep, SummaryStep } from "./RenderSteps";
import SuccessStep from "./SuccessStep";

interface FundWalletFlowProps {
  onClose: () => void;
  onPaymentSuccess: () => void;
  onPaymentError: () => void;
}

const FundWalletWorkFlow: React.FC<FundWalletFlowProps> = ({ onClose, onPaymentSuccess, onPaymentError }) => {
  const { step } = useFundWalletStore();


  useEffect(() => {
    // Cleanup on unmount
    return () => {
      useFundWalletStore.getState().resetFlow();
    };
  }, []);
  

  const renderStep = () => {
    switch (step) {
      case "amount":
        return <AmountStep />;
      case "summary":
        return <SummaryStep onClose={onClose} onPaymentSuccess={onPaymentSuccess} onPaymentError={onPaymentError} />;

      case "success":
        return <SuccessStep onClose={onClose} />;
      default:
        return <AmountStep />;
    }
  };

  return (
    <div className="font-sans w-full space-y-6 relative z-10">
      <div className="w-fit flex -mt-5 mx-auto">
        <PopUpDesign />
      </div>
      {renderStep()}
    </div>
  );
};

export default FundWalletWorkFlow;
